import { NavLink } from 'react-router-dom';
import { navGroups } from '../../constants/navigation.constants';
import { UserCard } from './UserCard';

interface AdminSidebarProps {
  user: any;
  allowedPaths: Set<string>;
  onLogout: () => void;
}

export function AdminSidebar({ user, allowedPaths, onLogout }: AdminSidebarProps) {
  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar-header">
        <a href="/" className="admin-sidebar-logo">
          <img src="/logo-singspace-blanc.png" alt="SingSpace" />
        </a>
      </div>

      <nav className="admin-sidebar-nav">
        {navGroups.map((group) => {
          const visible = group.items.filter((i) => allowedPaths.has(i.path));
          if (visible.length === 0) return null;
          return (
            <div key={group.label}>
              <p className="admin-nav-section">{group.label}</p>
              {visible.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => `admin-nav-item${isActive ? ' active' : ''}`}
                >
                  <span className="admin-nav-item-icon">
                    <item.icon />
                  </span>
                  <span className="admin-nav-item-text">
                    <span className="admin-nav-item-label">{item.label}</span>
                    <span className="admin-nav-item-desc">{item.desc}</span>
                  </span>
                </NavLink>
              ))}
            </div>
          );
        })}
      </nav>

      <UserCard user={user} onLogout={onLogout} />
    </aside>
  );
}
